import { Box, Truck } from "lucide-react";
import { cn } from "@/utils/cn";
import type { AtivoTipo } from "@/services/locacoes";

const TABS: Array<{ id: AtivoTipo; label: string; icon: typeof Truck }> = [
  { id: "maquinario", label: "Maquinário", icon: Truck },
  { id: "equipamento", label: "Equipamentos", icon: Box },
];

interface Props {
  value: AtivoTipo;
  onChange: (tipo: AtivoTipo) => void;
  disabled?: boolean;
  className?: string;
}

export function ContratoTipoTabs({ value, onChange, disabled, className }: Props) {
  return (
    <div
      className={cn(
        "flex rounded-lg border border-slate-200 bg-slate-50 p-0.5",
        disabled && "pointer-events-none opacity-60",
        className,
      )}
      role="tablist"
      aria-label="Tipo de contrato"
    >
      {TABS.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={value === id}
          disabled={disabled}
          onClick={() => onChange(id)}
          className={cn(
            "flex flex-1 items-center justify-center gap-1.5 rounded-md px-3 py-2 text-sm font-semibold transition-colors",
            value === id ? "bg-brand-50 text-brand-700 ring-1 ring-brand-200" : "text-slate-600 hover:bg-slate-100 hover:text-slate-800",
          )}
        >
          <Icon className="h-4 w-4 shrink-0" />
          {label}
        </button>
      ))}
    </div>
  );
}
